module.exports = __webpack_public_path__ + "static/media/dong-loading.ea120aaf.png";